import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";
import { DesignElementBase, DesignElementGroupableRequiredPart, DesignElementSlugPart } from "./base";
import { PageBlockV1 } from "./data";
import { DocumentationPageDataV2 } from "./data/documentation-page-v2";

export const DocumentationPageV2 = DesignElementBase.extend(DesignElementGroupableRequiredPart.shape)
  .extend(DesignElementSlugPart.shape)
  .extend({
    shortPersistentId: z.string(),
    data: DocumentationPageDataV2.extend({
      oldBlocks: z.array(PageBlockV1).optional(),
    }),
  });

export type DocumentationPageV2 = z.infer<typeof DocumentationPageV2>;

export type CreateDocumentationPageV2 = DbCreateInputOmit<DocumentationPageV2>;
export type UpdateDocumentationPageV2 = OmitStrict<DbUpdate<DocumentationPageV2>, "designSystemVersionId">;
export type RestoreDocumentationPage = CreateDocumentationPageV2 & { id: string; createdAt: Date; updatedAt: Date };
